import request from "@assets/js/axios";
const { instance: $axios } = request;
class User {
  constructor() { }
  // 更新地址
  updateAddress(data) {
    return $axios.post('/api/v1/address/' + data.id, {
      ...data,
      _method: 'PUT'
    })
  }
  // 删除地址
  deleteAddress(id) {
    return $axios.post("/api/v1/address/" + id, {
      id,
      _method: "DELETE",
    });
  }
  // 获取地址列表
  getAddress() {
    return $axios.get("/api/v1/address/byUserId");
  }
  // 添加地址
  addAddress(data) {
    return $axios.post("/api/v1/address/store", data);
  }
  //修改密码
  updatePassword(data) {
    return $axios.post('/user/resetpwd', data);
  }
  // 更新用户信息
  updateInfo(data) {
    // return $axios.post("/user/updateByIp", data);
    return $axios.post("/user/updateByHtml", data);
  }
  // 注册
  register({ phone, code, is_apply_distributor }) {
    // return $axios.post("/user/storeByIp", {
    return $axios.post("/user/storeByHtml", {
      phoneNumber: phone,
      phoneCode: code,
      is_apply_distributor
    });
  }
  // 登录
  login(data) {
    // return $axios.post("/user/onLogin", data);
    // return $axios.post("/user/onLoginV3", data);
    return $axios.post("/user/onLoginByHtml", data);
  }
  // 发送短信验证码
  sendSMS(phone) {
    return $axios.post("/user/getPhoneCodeByIp", { phoneNumber: phone });
  }
  // 获取重置密码的短信
  getPhoneCodeWithResetPWD() {
    return $axios.get('/user/getPhoneCodeWithresetpwd');
  }
  getDistributorDesc() {
    return $axios.get('/user/distributorProtocol');
  }
  checkLogin() {
    return $axios.get('/api/v2/user/checkLogin')
  }
}

export default new User();